import { createAction, props } from '@ngrx/store';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';

import { AccountFinalization } from '../models/account-finalization.model';
import { AccountVerification } from '../models/account-verification.model';

export const pageEnter = createAction('[Account Verification] Activate account');

export const activateAccountSuccess = createAction(
   '[Account Verification] Activate account Success',
   props<{ accountVerification: AccountVerification }>()
);

export const activateAccountFailure = createAction(
   '[Account Verification] Failed to Verify Account Information',
   props<RestApiError>()
);

export const retrievedCanAccountBeFinalizedSuccess = createAction(
   '[Account Verification] Can account be finalized Success.',
   props<{ canAccountBeFinalized: boolean }>()
);

export const retrievedCanAccountBeFinalizedFailure = createAction(
   '[Account Verification] Can account be finalized failed.',
   props<RestApiError>()
);

export const savePassword = createAction(
   '[Account Verification] Save password.',
   props<{ accountFinalization: AccountFinalization }>()
);

export const savePasswordSuccess = createAction('[Account Verification] Save password Success');

export const savePasswordFailure = createAction('[Account Verification] Save password failed', props<RestApiError>());
